// extracted by mini-css-extract-plugin
export default {"floatingBtn":"FloatingContactButton_floatingBtn__SmNw4"};